export const environment = process.env.REACT_APP_ENVIRONMENT
export const sentryDsn = process.env.REACT_APP_SENTRY_DSN
